import { Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppNotification } from '../../models/notification';
import { ProtuneApiService } from '../../services/protune-api.service';

@Component({
  selector: 'app-notification-modal',
  standalone: true,
  imports: [],
  templateUrl: './notification-modal.component.html',
  styleUrl: './notification-modal.component.scss'
})
export class NotificationModalComponent {
  @Input() notifications: AppNotification[];

  idx: number = 0;

  constructor(private activeModal: NgbActiveModal, private protuneApiService: ProtuneApiService) { }

  close() {
    this.activeModal.close();

  }

  next() {
    this.idx = (this.idx + 1) % this.notifications.length;
  }

  prev() {
    this.idx = (this.idx - 1) % this.notifications.length;

  }

  dismissNotification() {
    let ids = [this.notifications[this.idx].id];

    this.protuneApiService.acknowledgeAppNotifications(ids)
      .subscribe({
        next: () => {
          this.notifications.splice(this.idx, 1);
          this.idx = this.idx % this.notifications.length;

          if (this.notifications.length == 0) {
            this.close();
          }
        }
      })

    
  }

  dismissAllNotifications() {
    let ids = this.notifications.map(x => x.id);
    //mark all notifications as read for this profile
    this.protuneApiService.acknowledgeAppNotifications(ids)
      .subscribe({
        next: () => {
          this.activeModal.close();
        }
      })
  }
}
